export default __webpack_public_path__ + "static/media/lose.349ba82d.png";